import SiHaDocumentationListModelBase from '../_generated/modelBases/si-ha-documentation-list-model-base';

export default class SiHaDocumentationListModel extends SiHaDocumentationListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
